import React from 'react';
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, XAxis, YAxis } from 'recharts';

interface SparklineChartProps {
  data: number[];
  width?: number | string;
  height?: number;
  lineColor?: string;
  fillColor?: string;
}

const SparklineChart: React.FC<SparklineChartProps> = ({
  data,
  width = 220,
  height = 52,
  lineColor = '#2f5be7',
  fillColor = '#d9e5ff',
}) => {
  const isSinglePoint = data.length === 1;
  const safeData = data.length === 0
    ? [0, 0, 0, 0, 0, 0, 0]
    : data;
  const chartData = safeData.map((value, index) => ({
    index,
    value,
  }));
  const singlePointYMax = Math.max((safeData[0] || 0) * 1.25, 1);

  const chartWidth = typeof width === 'number' ? `${width}px` : width;

  return (
    <div style={{ width: chartWidth, height }} role="img" aria-label="Metrics trend sparkline">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={chartData} margin={{ top: 1, right: 1, bottom: 1, left: 1 }}>
          {isSinglePoint && (
            <>
              <XAxis dataKey="index" hide={true} />
              <YAxis hide={true} domain={[0, singlePointYMax]} tickCount={3} />
              <CartesianGrid stroke="#e7edf6" vertical={false} strokeDasharray="2 3" />
            </>
          )}
          <Area
            type="monotone"
            dataKey="value"
            stroke={lineColor}
            strokeWidth={2.5}
            fill={fillColor}
            fillOpacity={0.9}
            dot={isSinglePoint ? { r: 3, fill: lineColor, stroke: '#ffffff', strokeWidth: 1.5 } : false}
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SparklineChart;
